export const LOADER_SIZE = {
    tiny: 'tiny',
    normal: 'normal',
} as const

export const LOADER_THEME = {
    light: 'light',
    currentColor: 'currentColor',
} as const
